export default __webpack_public_path__ + "static/media/v2_262.bb13e86c.png";